function makePwdToggler(pwd: HTMLInputElement) {
  // Create show-password checkbox
  const checkbox = document.createElement('input');
  checkbox.setAttribute('type', 'checkbox');
  const id = pwd.id + 'toggler';
  checkbox.setAttribute('id', id);

  const label = document.createElement('label');
  label.setAttribute('for', id);

  const span = document.createElement('span');
  span.classList.add('visually-hidden');
  span.appendChild(document.createTextNode('show password'));
  label.appendChild(span);

  const div = document.createElement('div');
  div.classList.add('show-password');
  div.appendChild(checkbox);
  div.appendChild(label);

  // Add show-password checkbox under password input
  pwd.insertAdjacentElement('afterend', div);

  checkbox.onclick = () => toggle(pwd);
  // For non-mouse usage
  checkbox.onkeydown = () => toggle(pwd);
}

// Add toggle password callback
function toggle(pwd: HTMLInputElement) {
  if (pwd.type === 'password'){
    pwd.type = 'text';
  } else {
    pwd.type = 'password';
  }
}

function setupPwdTogglers() {
  const pwdInputs = document.querySelectorAll('input[type=password]');
  
  for (let i = 0; i < pwdInputs.length; i++) {
    makePwdToggler(pwdInputs[i] as HTMLInputElement);
  }
}

setupPwdTogglers();